import axios from 'axios'
import { getApiBaseUrl } from './apiBaseUrl'

// 开发：相对路径 → devServer 反代
// 生产：默认 https://domovieapi.pluskeji.cn（见 .env.production）；Nginx 同源反代时可设 VUE_APP_API_BASE_URL=/
const API_BASE_URL = getApiBaseUrl()

// 创建 axios 实例（关闭前端超时时间限制）
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 0 // 0 表示不做超时限制，由后端自行控制
})

/** Web 会员/积分收银：走支付宝当面付扫码（后端需 Client-Type 含 miniapp + payment_method=alipay） */
export const API_CLIENT_TYPE_ALIPAY_SCAN = 'wechat-h5-miniapp-web'

function attachPayClientTypeHeader(config) {
  const url = String((config && config.url) || '')
  if (!/\/vip-orders\b|\/asset\/score-order\//.test(url)) return
  if (!config.headers) config.headers = {}
  if (!config.headers['Client-Type']) {
    config.headers['Client-Type'] = API_CLIENT_TYPE_ALIPAY_SCAN
  }
}

// 请求拦截器
api.interceptors.request.use(
  config => {
    attachPayClientTypeHeader(config)
    const token = localStorage.getItem('token') || sessionStorage.getItem('token')
    if (token) {
      config.headers.Authorization = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    // 只在确实需要认证的接口返回 401 时才跳转
    // 但不要在所有 401 时都跳转，让组件自己决定如何处理
    // 特别是获取用户信息这种非关键接口，失败不应该导致退出登录
    if (error.response && error.response.status === 401) {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token')
      // 如果有 token 但返回 401，可能是 token 无效
      // 但不要立即跳转，让组件自己处理
      // 只有在组件明确清除 token 后，才在下次请求时跳转
      if (token) {
        // 不在这里处理跳转，让组件决定
        console.warn('API 返回 401，但保留 token，让组件处理')
      }
    }
    return Promise.reject(error)
  }
)

export default api


